module.exports = __webpack_public_path__ + "static/media/menu.7ace2d97.svg";